var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVideoOff = function SvgVideoOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.219 5h-.021L3.113 1.915a.847.847 0 1 0-1.198 1.198L3.802 5h-.469c-.92 0-1.666.746-1.666 1.667v6.666c0 .92.746 1.667 1.666 1.667H12.5c.367 0 .707-.119.982-.32l3.405 3.405a.847.847 0 1 0 1.198-1.198l-3.918-3.918v-.021L12.5 11.28v.021L7.865 6.667h.02L6.22 5ZM12.5 8.885V6.667h-2.219L8.615 5H12.5c.92 0 1.667.746 1.667 1.667v.714l2.92-1.669a.833.833 0 0 1 1.246.724v7.128a.833.833 0 0 1-.427.728l-3.396-3.396 2.157 1.232V7.872l-2.5 1.428v1.252L12.5 8.885ZM3.333 6.667H5.47l6.667 6.666H3.333V6.667Z"
  })));
};

export default SvgVideoOff;